import { Typography } from "@mui/material";

type SaleButtonProps = {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  url?: string;
};

const SaleButton = ({ title, subtitle, children, url }: SaleButtonProps) => {
  return (
    <div
      style={{
        borderRadius: "8px",
        width: "250px",
        alignSelf: "center",
        padding: "12px 16px",
        whiteSpace: "pre-wrap",
        zIndex: "100",
        textAlign: "center",
        cursor: url ? "pointer" : "auto",
      }}
      className="sale-button"
      onClick={() => url && window.open(url, "_blank")}
    >
      <Typography variant="h6">{title}</Typography>
      <Typography variant="subtitle2">{subtitle}</Typography>
      <Typography variant="body2">{children}</Typography>
    </div>
  );
};

export default SaleButton;
